import { logoConfig } from '../../constants/branding';

export const getProcessedImageForSave = ({ uppyFile, targetWidth, targetHeight }) =>
    new Promise((resolve, reject) => {
        const img = new Image();
        const objectUrl = URL.createObjectURL(uppyFile.data);
        img.src = objectUrl;
        const IMAGE_QUALITY_MULTIPLIER = 2;

        img.onload = () => {

            const maxWidth = targetWidth * IMAGE_QUALITY_MULTIPLIER;
            const maxHeight = targetHeight * IMAGE_QUALITY_MULTIPLIER;

            let { width, height } = img;

            const scale = Math.min(maxWidth / width, maxHeight / height, 1);
            const newWidth = Math.round(width * scale);
            const newHeight = Math.round(height * scale);

            const canvas = document.createElement('canvas');
            canvas.width = newWidth;
            canvas.height = newHeight;

            const ctx = canvas.getContext('2d');
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'high';

            ctx.drawImage(img, 0, 0, newWidth, newHeight);

            const base64String = canvas.toDataURL('image/png');
            URL.revokeObjectURL(objectUrl);
            resolve(base64String);
        };

        img.onerror = (error) => {
            URL.revokeObjectURL(objectUrl);
            reject(error);
        };
    });

export const getImageUrlForBrandingPage = (dataURL, maxWidth = logoConfig.MAX_WIDTH, maxHeight = logoConfig.MAX_HEIGHT, callback) => {
    const img = new Image();
    img.onload = () => {
        const scale = Math.min(maxWidth / img.width, maxHeight / img.height, 1);
        const newWidth = Math.round(img.width * scale);
        const newHeight = Math.round(img.height * scale);

        const canvas = document.createElement('canvas');
        canvas.width = newWidth;
        canvas.height = newHeight;

        const ctx = canvas.getContext('2d');
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';

        ctx.drawImage(img, 0, 0, newWidth, newHeight);

        const resizedDataURL = canvas.toDataURL('image/png');
        callback(resizedDataURL);
    };

    img.src = dataURL;
};

export const resizeDataURLImageAsync = (dataURL, maxWidth = logoConfig.MAX_WIDTH, maxHeight = logoConfig.MAX_HEIGHT) =>
    new Promise((resolve, reject) => {

        const img = new Image();

        img.onload = () => {
            const scale = Math.min(maxWidth / img.width, maxHeight / img.height, 1);
            const newWidth = Math.round(img.width * scale);
            const newHeight = Math.round(img.height * scale);

            const canvas = document.createElement('canvas');
            canvas.width = newWidth;
            canvas.height = newHeight;

            const ctx = canvas.getContext('2d');
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'high';

            ctx.drawImage(img, 0, 0, newWidth, newHeight);
            resolve(canvas.toDataURL('image/png'));
        };

        img.onerror = reject;
        img.src = dataURL;
    });
